import React from 'react';
import styled from 'styled-components';

export const DataLinkButton = styled.button`
  font-size: 12px;
  line-height: 1.2;
  display: inline;
  background: ${({ theme }) => theme.colors.transparent};
  color: ${({ theme }) => theme.colors.primaryBase};
  padding: 0;
  border: 0;
  outline: 0;
  padding-bottom: 1px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primaryBase};
  cursor: pointer;
`;
const CustomDataLink = props => {
  const { data, schema, path = [], onClick } = props;
  return (
    <div className={`default-type-string depth-${path.length}`}>
      <strong className="default-type-string-title">{schema.title}</strong>{' '}
      <span className="default-type-string-value">
        <DataLinkButton
          className="default-format-data-link-button"
          onClick={onClick}
        >
          {data}
        </DataLinkButton>
      </span>
    </div>
  );
};

export default CustomDataLink;
